import { FC } from 'react'

import {
  useLoadFile,
  UseLoadFileOptions,
} from 'components/form-field/LoadFileFormField/useLoadFile'
import { BaseFormField, BaseFormFieldProps } from 'components/form-field/BaseFormField'
import { cn } from 'utils'
import { ErrorMessage } from 'components/error-message'

import commonClasses from '../../form-field.module.css'
import classes from './LoadFileFormField.module.css'

interface LoadFileFormFieldProps extends UseLoadFileOptions, BaseFormFieldProps {
  name: string
}

export const LoadFileFormField: FC<LoadFileFormFieldProps> = ({
  name: fieldName,
  accept: outerAccept,
  maxFileSize,
  ...rest
}) => {
  const { fieldError, fileInfo, onChange, inputRef, accept, name } = useLoadFile({
    maxFileSize,
    accept: outerAccept,
    name: fieldName,
  })

  return (
    <BaseFormField {...rest}>
      <label
        className={cn(commonClasses.field, fieldError && commonClasses.errorField, classes.label)}
      >
        <span className={classes.fileName}>{fileInfo?.name || 'No file selected'}</span>

        <input
          type="file"
          accept={accept}
          name={name}
          className="visuallyHidden"
          ref={inputRef}
          onChange={onChange}
        />
      </label>
      {fieldError && <ErrorMessage>{fieldError.message}</ErrorMessage>}
    </BaseFormField>
  )
}
